module.exports = __webpack_public_path__ + "img/redirect-task.3b58e219.svg";